import React from 'react';
import { RouteFormatter } from '../../routes';
import SvgChevronRight from 'src/assets/svg/SvgChevronRight.svg';
import SvgPin from 'src/assets/svg/SvgPin.svg';
import './nearby-cities.scss';

const NearbyCity = ({ isMobile, city }) => {
    return (
        <a href={RouteFormatter.listings({ first: city.url })} className="nearby-city">
            <SvgPin className="me-2" />
            <span className="snif-p snif-medium">{city.name}</span>
            {isMobile && <SvgChevronRight className="chev-r" />}
        </a>
    );
};

const NearbyCities = ({ city, subObj }) => {
    if (city.otherCities.length == 0) {
        return '';
    }

    return (
        <div className="sniff-nearby">
            <div className="l-container">
                <h2 className="snif-m2 snif-l2-pc snif-semibold mb-2 mb-md-3">
                    Check out Sniffspot {subObj?.seoTitle.toLowerCase() || 'dog park'} in nearby cities
                </h2>
                <div className="d-md-flex">
                    {city.otherCities.map((c, i) => (
                        <NearbyCity key={i} city={c} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NearbyCities;
